<template>
  <div class="general">
    <el-card>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6">
          <el-link
            v-loading="activeTask"
            :element-loading-text="loadingText"
            :underline="false"
            @click.prevent="open"
            style="margin-bottom: 10px"
          >
            <img src="../../assets/browser-bar.png" class="browser" />
            <Screen class="border" :application="application" />
          </el-link>

          <el-button
            size="small"
            type="primary"
            icon="mdi mdi-open-in-new"
            @click="open"
          >
            Open in Browser
          </el-button>

          <el-button
            size="small"
            icon="el-icon-copy-document"
            @click="clone = true"
          >
            Clone
          </el-button>

          <Clone :application="application" :open.sync="clone" />
        </el-col>

        <el-col :xs="24" :sm="12" :md="16" :lg="16" :xl="18">
          <Config
            :bundle-id="application.bundleId"
            :version.sync="version"
            :package.sync="pkgVersion"
            :config.sync="config"
            @change="changes = true"
          />

          <div v-if="changes" class="buttons">
            <el-button
              type="primary"
              size="small"
              @click.prevent="save"
            >
              Save and restart
            </el-button>

            <el-button
              type="info"
              size="small"
              icon="el-icon-close"
              @click="cancel"
            >
              Cancel
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <DevOpsSettings
      v-if="devops"
      class="devops"
      :instance="instance"
      :application="application"
    />

    <Console
      v-if="console"
      :application="application"
      :offset="500"
    />

    <component
      v-bind:is="dashboard"
      class="dashboard"
      :application="application"
      :config.sync="config"
      @change="save"
    />

    <div class="alerts">
      <el-button
        v-if="config.backup !== '1'"
        type="text"
        class="warning"
        icon="el-icon-warning-outline"
        @click="$router.push('/instances/' + instance.id + '/' + application.id + '/backups')"
      >
        backups are not activated.
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Config from './Config'
import Clone from './Clone'
import Console from './Console'
import Screen from './Screen'
import DashboardWordpress from './Dashboard/Wordpress'
import DevOpsSettings from './DevOps/Settings'

export default {
  props: {
    instance: Object,
    application: Object,
    activeTask: Object
  },
  components: {
    Config,
    Clone,
    Console,
    Screen,
    DashboardWordpress,
    DevOpsSettings
  },
  data () {
    return {
      changes: false,
      clone: false,
      version: this.application.version,
      pkgVersion: this.application.package,
      config: { ...this.application.config || {} }
    }
  },
  mounted () {
    if (this.activeTask) {
      this.$notify({
        title: 'Task in progress',
        message: 'Application shutdowns may occur',
        showClose: false,
        position: 'bottom-right',
        type: 'info'
      })
    }
  },
  computed: {
    loadingText () {
      return this.application.state !== 'running' ? this.application.state : null
    },
    dashboard () {
      const name = this.application.bundleId.charAt(0).toUpperCase() + this.application.bundleId.slice(1)
      return this.application.bundleId.match(/wordpress/) ? `Dashboard${name}` : null
    },
    console () {
      return this.$root.bundles[this.application.bundleId].console
    },
    ...mapState(['devops'])
  },
  methods: {
    open () {
      window.open(this.applicationUrl(this.application.config), '_blank')
    },
    cancel () {
      this.config = { ...this.application.config || {} }
      this.changes = false
    },
    save () {
      this.$emit('save', {
        version: this.version,
        package: this.pkgVersion,
        config: this.config
      })
      this.changes = false
    },
    restart () {
      this.$confirm('Will relaunch the application. Continue?', 'Warning', {
        confirmButtonText: 'Restart',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => this.$store.dispatch('restartApplication', this.application))
        .catch(() => {})
    }
  },
  watch: {
    'application.version' (value) {
      this.version = value
    },
    'application.package' (value) {
      this.pkgVersion = value
    },
    'application.config' (value) {
      this.config = { ...value || {} }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .general {
    max-width: 1000px;
  }

  .console, .dashboard, .devops {
    margin-top: 24px;
  }

  .el-link {
    display: block;
    width: 100%;

    .browser {
      max-width: 100%;
    }

    .screen {
      display: block;
      width: calc(100% - 2px);
      height: auto;

      &.border {
        border: 1px solid #333333;
        border-top: 0;
        margin-top: -3px;
      }
    }
  }

  .buttons {
    padding-left: 155px;

    .el-button {
      margin-top: 15px;
    }
  }

  .alerts {
    margin-top: 5px;

    .el-button {
      font-size: 12px;

      &.warning {
        color: $--color-warning;
      }
    }
  }
</style>

<style lang="scss">
  @import "../../theme";

  .dashboard > .el-card__body > .el-row {
    margin: -12px !important;

    .el-col {
      border-left: 1px solid $--border-color-base;
      border-right: 1px solid $--border-color-base;
      margin-right: -1px;
      padding-top: 12px;
      padding-bottom: 12px;

      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
        margin-right: 0;
      }
    }
  }
</style>
